import React from 'react';
import { useEffect, useState } from 'react';

// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";

// react-bootstrap components
import {
    Card,
    Form,
    Container,
    Row,
    Col,
    Button,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";

export default function DateSelect(props) {
    return (
        <>
            <h5 className="title">{props.title}</h5>
            <Form.Group className="date-select">
                {props.withSteppers != false ? <OverlayTrigger
                    overlay={
                        <Tooltip>Previous day</Tooltip>
                    }
                >
                    <Button
                        className="btn-link btn-xs btn-icon"
                        href="#pablo"
                        onClick={props.prevDayClick}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </Button>
                </OverlayTrigger> : null}

                <ReactDatetime
                    renderInput={params => (
                        <input
                            {...params}
                            onKeyDown={e => e.preventDefault()}

                        />)}
                    inputProps={{
                        className: props.error ? "form-control is-invalid custom-input" : "form-control custom-input",
                        placeholder: "Date Picker Here"
                    }}
                    timeFormat={props.time ? props.time : false}
                    dateFormat={props.format ? props.format : "DD/MM/YYYY"}
                    onChange={(date) => props.handleChange(date)}
                    value={props.value}
                    closeOnSelect={true}
                ></ReactDatetime>

                {props.withSteppers != false ? <OverlayTrigger
                    overlay={
                        <Tooltip>Next day</Tooltip>
                    }
                >
                    <Button
                        className="btn-link btn-xs btn-icon"
                        href="#pablo"
                        onClick={props.nextDayClick}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </Button>
                </OverlayTrigger> : null}
            </Form.Group>
        </>
    );
}
